import Vue from 'vue'
var constants = {
  UPMS: 'dll/upms/',
  DOCS: 'dll/upms/',
  MONITOR: '',
  CENTRAL_CONTROL: 'dll/central/',
  WECHAT: 'dll/wechat/',
  WORKFLOW: 'dll/lightApplication/',
  EXAM: 'dll/lightApplication/',
  PROJECTS_ID: '6820311175',
  APP_ID: '602394140839161856',
  APP_KEY: 'e027565ee9954929a41c152deecdf1c1',
  APPLICATION_NAME: 'dll-lightApplication',

  // 工作流
  FILE_CATALOG_WORK_FLOW: '676669645926580224',

  // 流程表单
  FILE_CATALOG_WORK_FLOW_FORM: '676669242837188608',
  // 工单
  FILE_CATALOG_WORK_ORDER: '676938639661219840'

}

Vue.prototype.constants = constants
export default constants
